import styled from 'styled-components';
import { StyledBaseIcon } from '../../Icons/Base.icon';
import React from 'react';
import CatSleepIcon from '../../Icons/Cat/CatGlass.icon';
import { useTranslation } from 'react-i18next';

const StyledNoResultTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  text-align: center;
`;
const StyledNoResult = styled.div`
  width: 100%;
  height: calc(100vh - 350px);
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;

  & > ${StyledBaseIcon} {
    opacity: 0.15;
  }
`;

export const NotificationsModalEmptyListComponent = () => {
  const { t } = useTranslation();

  return (
    <StyledNoResult>
      <CatSleepIcon />
      <StyledNoResultTitle>{t('No unread notifications')}</StyledNoResultTitle>
    </StyledNoResult>
  );
};
